import type { ReactNode } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { EMPTY_VALUE } from '@/constants/app.constants';

interface DetailValueProps {
  isLoading: boolean;
  children: ReactNode;
}

export function DetailValue({ isLoading, children }: DetailValueProps) {
  if (isLoading) return <Skeleton className="h-4 w-32 max-w-full" />;
  if (children === null || children === undefined || children === '') return EMPTY_VALUE;
  return children;
}
